import React from 'react';
import './games.css';
import {gameData} from './gameData';
import { gameDataBeta } from './gameData2';


export class Games extends React.Component {
  constructor() {
    super();
    this.state = {
      viewMode: "menu",
      title: "",
      author: "",
      desc: "",
      resX: "200px",
      resY: "200px",
      link: ""
    }
  }

  handlePlayGame = (gameID) => {
    this.setState(
      {
        viewMode: "game",
        title: gameData[gameID].title,
        author: gameData[gameID].author,
        desc: gameData[gameID].desc,
        resX: "800px", 
        resY: "600px",
        link: gameData[gameID].link
      }
    )
  }

  stopButton = () => {
    this.setState(
      {viewMode: "menu", title: "", author: "", desc: "", resX: "200px", resY: "200px", link: ""}
    )
  }




    render() {

      if (this.state.viewMode === 'menu') {
        return(
          <div>
   
        <div class = "game-nav">
         {gameData.map(game => 
            <div class = "game-nav-but" onClick={()=> this.handlePlayGame(game.id)} key={game.id}>{game.title}</div>
          )}
        </div>
        </div>
        )
      }

      else if (this.state.viewMode === 'game') {
        return(
          <div class="game-box">
          <div class="game-box-a">

           <h1>{this.state.title}</h1>
          <p>{this.state.author}</p>
           <p>{this.state.desc}</p>
           <div class = "game-box-stop" onClick = {()=> this.stopButton()}>
           <p>Stop the Game</p>
           </div>
          </div>
  
          <div class="game-box-b">
          <iframe title = "game" src = {this.state.link} width = {this.state.resX} height = {this.state.resY} allowFullScreen />
          </div>
          </div>
        )
      }
      
    }
  } 

export class Games_Beta extends React.Component {
  constructor() {
    super();
    this.state = {
      viewMode: "games", 
      title: "", 
      author: "", 
      description: "", 
      link: ""
    }
  }


  render () {

    if (this.state.viewMode === "menu") {
      return(
        <div>
          <div class = "game-nav">
          {gameDataBeta.map(program=>
          <div class = "game-nav-but" key = {program.id}>{program.program}</div>)}
          </div>
        </div>
      )
    }
    
    if (this.state.viewMode === 'games') {
      return(
        <div>
          <div class = "game-nav">
            {gameDataBeta.map(program =>
              <div class = "game-nav-but" key = {program}>{program.program}</div>)}
          </div>
        </div>
      )
    }
  }
}